export default __webpack_public_path__ + "static/media/menu-icon.255c50ff.svg";